import { Modal, ModalBody } from 'reactstrap';
import Button from '../ui/Button';
import { useEffect, useState } from 'react';
import moment from 'moment';

interface CheckInOutModalProps {
  isOpen: boolean;
  type: 'checkIn' | 'checkOut' | null;
  toggle: (type: 'checkIn' | 'checkOut' | null) => void;
  onConfirm: () => void;
  loading: boolean;
}

const CheckInOutConfirmModal = ({
  isOpen,
  type,
  toggle,
  onConfirm,
  loading
}: CheckInOutModalProps) => {
  const isCheckIn = type === 'checkIn';
  const [currentTime, setCurrentTime] = useState<string>(
    moment().format('hh:mm A'),
  );

  useEffect(() => {
    let intervalId: NodeJS.Timeout;

    if (isOpen) {
      setCurrentTime(moment().format('hh:mm A'));
      intervalId = setInterval(() => {
        setCurrentTime(moment().format('hh:mm A'));
      }, 1000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={() => toggle(null)} centered>
      <ModalBody className="text-center">
        <div className="d-flex flex-column justify-items-center align-items-center gap-3">
          <span
            className="icon bg-primary-subtle text-primary mb-3"
            style={{ boxShadow: '#0047ab33 0px 0px 8px 3px' }}
          >
            <i
              className={`bi ${isCheckIn ? 'bi-box-arrow-in-right' : 'bi-box-arrow-right'
                }`}
              style={{ fontSize: '24px' }}
            ></i>
          </span>

          <h4 className="fw-semibold mb-1">
            {isCheckIn ? 'Check-In' : 'Check-Out'} Confirmation
          </h4>

          <p className="text-muted mb-3">
            You are about to {isCheckIn ? 'Check-In' : 'Check-Out'} for
            today.
          </p>

          <div className="border rounded-3 py-2 mb-4 w-100">
            <div className="small text-muted">
              {isCheckIn ? 'Check-In' : 'Check-Out'} time
            </div>
            <div className="fw-semibold fs-3">{currentTime}</div>
          </div>
        </div>
        <div className="row m-0 w-100">
          <div className="col-12 col-md-6">
            <button
              type="button"
              className="btn btn-secondary w-100"
              onClick={() => toggle(isCheckIn ? 'checkIn' : 'checkOut')}
            >
              Cancel
            </button>
          </div>
          <div className="col-12 col-md-6">
            <Button
              className={'btn btn-primary w-100 '}
              type="button"
              isLoading={loading}
              onClick={onConfirm}
            >
              {isCheckIn ? 'Check-In' : 'Check-Out'}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CheckInOutConfirmModal;
